import * as React from "react";

function Dashboard({color="var(--color-blue-500)",...props}) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 21 20" fill="none" {...props}>
      <rect
        x={1}
        y={1}
        width={19}
        height={18}
        rx={3}
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
      />
      <path
        d="M1 6.5h18.5M8.5 7v11.5"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
      />
    </svg>
  );
}

export default Dashboard;
